import React, { useMemo, useState } from 'react';
import './index.scss';
import {
  Button,
  Form,
  Modal,
  SearchBox,
  TextArea,
  notification,
} from 'tea-component';
import { setReportInsightSubscribe } from '@/pages/opinion/services';
import { useIntl } from 'umi';
import { debounce } from 'lodash-es';
import EmailInput from '@/pages/opinion/components/EmailInput';

const SubscribeModal = ({
  visible,
  close,
  gameInfo,
  wholeGameInfo,
  successCallback,
}: any) => {
  const [title, setTitle] = useState<string>(
    `【${wholeGameInfo.entity_name}】 Newsletter Updated on DataBrain Opinions - IEGG ADG`,
  );
  const [emailList, setEmailList] = useState<Array<string>>([]);
  const [showNameMessage, setShowNameMessage] = useState(false);
  const [showEmailMessage, setShowEmailMessage] = useState(false);
  const [remarks, setRemarks] = useState('');

  const { formatMessage } = useIntl();
  const submitSubscribe = () => {
    const params = {
      ...gameInfo,
      title: title,
      emails: emailList,
      remark: remarks,
    };
    setReportInsightSubscribe(params)
      .then(() => {
        successCallback?.();
        close();
        notification.success({
          description: formatMessage({ id: 'Subscription successful.' }),
        });
      })
      .catch(() => {
        notification.error({
          description: formatMessage({ id: 'Subscription failure' }),
        });
      });
  };

  const inputChange = useMemo(() => {
    return debounce((value: string) => {
      setTitle(value);
      setShowNameMessage(value.trim() === '');
    }, 50);
  }, []);

  return (
    <Modal
      className="dbo-report-modal"
      visible={visible}
      caption={formatMessage({ id: 'Subscribe' })}
      onClose={() => close()}
    >
      <Modal.Body>
        <div className="dbo-report-modal-text">
          {formatMessage({
            id: 'Once the newsletter is updated, we will notify you by email.',
          })}
        </div>
        <Form>
          <Form.Item
            label={formatMessage({ id: 'Title' })}
            status={showNameMessage ? 'error' : undefined}
            required
            message={
              showNameMessage
                ? formatMessage({ id: 'Email title must be filled in.' })
                : ''
            }
            showStatusIcon={false}
          >
            <SearchBox
              value={title}
              onChange={inputChange}
              placeholder={formatMessage({ id: 'Please enter email title.' })}
            />
          </Form.Item>
          <Form.Item
            className="dbo-report-modal-item"
            required
            label={formatMessage({ id: 'Email' })}
            showStatusIcon={false}
            status={showEmailMessage ? 'error' : undefined}
            message={
              showEmailMessage
                ? formatMessage({
                    id: 'Please enter the correct email address',
                  })
                : ''
            }
          >
            <EmailInput
              className="dbo-report-modal-tagSelect"
              value={emailList}
              placeholder={formatMessage({
                id: 'Please enter a Email',
              })}
              onChange={(tags, isError) => {
                setEmailList(tags);
                setShowEmailMessage(isError);
              }}
            />
          </Form.Item>
          <Form.Item
            className="dbo-report-modal-item"
            label={formatMessage({ id: 'Remarks' })}
          >
            <TextArea
              showCount
              size="full"
              value={remarks}
              onChange={(value) => {
                setRemarks(value);
              }}
              placeholder={formatMessage({
                id: "You can provide some suggestions or other reports you'd like to subscribe to.",
              })}
            />
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => submitSubscribe()}
          disabled={
            emailList.length === 0 || showNameMessage || showEmailMessage
          }
        >
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button type="weak" onClick={() => close()}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubscribeModal;
